import React from 'react';
import { SalesTab } from './SalesTab';

export const Sales: React.FC = () => {
  return (
    <div className="space-y-6">
      <SalesTab />
    </div>
  );
};
